<template>
  <div>
    

    <div class="mobileFooter">
      <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/footerLogo.png" alt="logo" class="footerLogo">

      <div class="partner">
        <div class="name">数字会展合作伙伴</div>
        <img class="partnerIcon" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/txlogo.png" alt="">
        <img class="partnerIcon" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/wmlogo.png" alt="">
      </div>

      <div class="partner">
        <div class="name">数字化注册合作伙伴</div>
        <img class="partnerIcon" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/infologo.png" alt="">
      </div>

      <!-- 二维码 -->
      <div class="contactUs">
        <div class="title">联系我们</div>
        <div>
          <p class="subTitle">上海市会展行业协会</p>
          <p class="subTitle">上海市青浦区诸光路1588号L3B座603室</p>
          <p class="subTitle">邮箱：sceia2002@163.com</p>
          <p class="subTitle">电话：+86-21-38452001</p>
        </div>
      </div>
      <div class='flexBox'>
        <div class="qrCodeBox">
          <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/gjhzyceo.png" alt="小程序二维码" class="qrCodeImg">
          <p class="name">国际会展业CEO峰会公众号</p>
        </div>
        <div class="qrCodeBox">
          <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/shhzhyxh.png" alt="小程序二维码" class="qrCodeImg">
          <p class="name">上海市会展行业协会公众号</p>
        </div>
        <div class="qrCodeBox">
          <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/ceomini.png" alt="小程序二维码" class="qrCodeImg">
          <p class="name">国际会展业CEO上海峰会小程序</p>
        </div>
      </div>
      <div class="fixBottom">
        Copyright © Global Exhibition CEO Shanghai Summit
      </div>

    </div>

  </div>

</template>

<script>
export default {
  name: 'wmt-footer',

  data() {
    return {

    }
  },

  mounted() { },

  methods: {

  },
}
</script>

<style lang="less" scoped>
// @font-face {
//   font-family: 'iconfont';  /* Project id 3984719 */
//   src: url('https:////at.alicdn.com/t/c/font_3984719_iwy98fnpxn8.woff2?t=1680577395903') format('woff2'),
//        url('https:////at.alicdn.com/t/c/font_3984719_iwy98fnpxn8.woff?t=1680577395903') format('woff'),
//        url('https:////at.alicdn.com/t/c/font_3984719_iwy98fnpxn8.ttf?t=1680577395903') format('truetype');
// }
.footerBox {
  display: flex;
  justify-content: space-between;
  position: relative;
  .wemeetLogo {
    font-size: 80px;
    color: #fff;
  }
  .moduleContainer {
    padding-top: 40px;
    position: relative;
    height: 428px;
  }
  .footerLogo {
    margin-top: 20px;
    width: 287px;
    // height: 58px;
  }
  .partner {
    display: flex;
    align-items: center;
    margin-top: 50px;
    .name {
      font-size: 16px;
      font-weight: 400;
      color: #fcfcfc;
      width: 160px;
      margin-right: 20px;
    }
    .partnerIcon {
     
      font-size: 30px;
      color: #fff;
      margin-right: 37px;
    }
  }

  .qrCode {
    display: flex;
    align-items: center;
    margin-left: 50px;
    .contactUs {
      margin-right: 90px;
      padding-top: 40px;
      .title {
        font-size: 15px;
        font-weight: 400;
        color: #ffffff;
        text-align: left;
        margin-bottom: 20px;
      }
      .subTitle {
        font-size: 15px;
        font-weight: 400;
        color: #999999;
        margin-bottom: 16px;
      }
    }
    .title {
      font-size: 15px;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      margin-bottom: 16px;
    }
    .qrCodeImg {
      width: 112px;
      height: 113px;
    }
  }
  .flexBox {
    padding-left: 85px;
    .qrCodeBox {
      margin-right: 28px;
      .qrCodeImg {
        width: 89px;
        height: 89px;
      }
      .name {
        font-size: 11px;
        font-weight: 400;
        color: #fcfcfc;
        width: 89px;
        text-align: center;
      }
    }
  }
}
.fixedBottom {
  width: 100%;
  height: 90px;
  border-top: 1px solid #373b40;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #888;
  padding-top: 22px;
  margin-top: 50px;
  p {
    margin-bottom: 10px;
  }
  a {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888;
    margin-right: 10px;
  }
}
// 移动端
.mobileFooter {
  width: 100%;
  background: #212531;
  text-align: center;
  .footerLogo {
    width: auto;
    height: 35px;
    margin-top: 19px;
    margin-bottom: 28px;
  }
  .partner {
    display: flex;
    align-items: center;
    margin-top: 17px;
    text-align: left;
    padding-left: 28px;
    .name {
      font-size: 14px;
      font-weight: 400;
      color: #fcfcfc;
      min-width: 125px;
      margin-right: 20px;
    }
    .partnerIcon {
      width: 65px;
      font-size: 14px;
      color: #fff;
      margin-right: 15px;
    }
  }

  .contactUs {
    padding-top: 40px;
    display: flex;
    padding-left: 25px;
    .title {
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      text-align: left;
      margin-right: 25px;
      width: 80px;
    }
    .subTitle {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      margin-bottom: 8px;
      padding-right:10px ;
      text-align: left;
    }
  }

  .flexBox {
    padding-left: 35px;
    display: flex;
    .qrCodeBox {
      margin-right: 28px;
      .qrCodeImg {
        width: 89px;
        height: 89px;
      }
      .name {
        font-size: 11px;
        font-weight: 400;
        color: #fcfcfc;
        width: 89px;
        text-align: center;
      }
    }
  }
  .fixBottom {
    width: 100%;
    height: 50px;
    text-align: center;
    margin-top: 50px;
    line-height: 48px;
    border-top: 1px solid #3f424b;
    font-size: 11px;
    font-weight: 400;
    color: #999999;
  }
}
</style>